import React from 'react';
const common = require('../common/common');
const multibrand = require('../common/multibrand');
const env = require("../../config.js").default;

class FilterChassis extends React.Component{
	constructor(props){
		super(props);
		this.state = {};
		this.state.tagliando = {};
		this.state.userInfo = {};
		this.state.request_url = this.props.request_url;
		this.state.newTicket = this.props.newTicket
		this.state.count_campagne = 0
		this.state.campagne = []
		this.state.righe_campagne = ""

		common.getUserInfo().then(userInfo => {
		this.setState({ userInfo: userInfo });
		})
 	}

	componentDidMount(){
		const $ = window.$;
		let url = "";
		$("#resetta_ricerca").hide();
		$("#button-campagne").hide()
		var url_string = window.location.href;
		var url_link = new URL(url_string);
		const params = url_link.searchParams;
		if ([...params].length > 0) {
			const paramObject = {};
			for (const [key, value] of params.entries()) {
				paramObject[key] = value;
			}
			if ((Object.keys(paramObject)).includes('NT')) {
				let nt = paramObject['NT']
				$("#EDTNTELA").val(nt).trigger("change")
			}
		}
		$("#btn_cercaT").click((e) => {
			e.preventDefault();
			if($("#EDTNTELA").val() === ''){
				$("input#EDTNTELA").addClass("is-invalid").attr("placeholder", common.getTrad("Inserisci il telaio..."));
			}else{
				$('#select_vm').attr("disabled", true)
				$("input#EDTNTELA").removeClass("is-invalid").attr('readonly','readonly');
				$("#btn_cercaT").addClass("loading").attr("disabled", true);
				common.set_localStorage("valoreVIN", $("#EDTNTELA").val());

				if(this.state.request_url !== undefined && this.state.request_url !== null){
					multibrand.is_multibrand_portal() ? url = this.state.request_url + "&telaio=" + $("#EDTNTELA").val() : url = this.state.request_url + $("#EDTNTELA").val() + "&marca=" + this.props.marcaDefault
					common.apiCall(url, "GET", {}, true)
					.then(response=>{
						$("#resetta_ricerca").show();
						$("#btn_cercaT, #erroreVIN").hide().removeClass("loading").attr("disabled", false);
						if(response.errorCode){
							$("#erroreVIN").show();
							if(response.message !== undefined && response.message !== null)
						$('#erroreVIN').html(response.message);
						}

						this.props.onClick(response);
						if (response['veicolo'] && response['veicolo']['campagne'] && this.state.newTicket){
							var campagne = response['veicolo']['campagne']
							if(!campagne || campagne.length === 0){
								$("#button-campagne").show()
								$("#button-campagne").prop('disabled', true);
							}else{
								$("#button-campagne").show()
								$("#button-campagne").removeClass("btn btn-light").addClass("btn btn-danger")
								var righe = ""
								for (let i = 0; i < campagne.length; i++) {
									if (campagne[i].CCAMPWCA) {
										righe = righe + '<tr><td>' + campagne[i].CCAMPWCA +  '</td><td>' + campagne[i].DCAMPACA + '</td></tr>';
									}
								}
								this.setState({ count_campagne: campagne.length, righe_campagne : righe})
								$('#intCampagnaModal table tbody').html(righe)
							}
						}
					})
				}
			}
		});

		if (this.props.tableType !== 'content' && this.props.tableType !== 'default'){
			$("#select_vm").on("change", (e) => {
				this.props.onClick({});
				$(".select_ticket").val("").trigger("change")
			});
		}

		$("#resetta_ricerca").click((e) => {
			e.preventDefault();
			$('#select_vm').attr("disabled", false)
			$("select#select_model option[value='"+ window.valoreModello + "']").removeAttr("selected","selected");
			$("input#EDTNTELA").val("").removeAttr('readonly');
			$('#ricerca_filtro_modello .select_modelli').val('').trigger('change');
			$("#button-campagne").prop('disabled', false);
			$("#button-campagne").removeClass("btn btn-danger").addClass("btn btn-light")
 			$("#btn_cercaT").show();
			common.remove_localStorage('valoreVIN');
			$("#resetta_ricerca,#erroreVIN,#erroreModello").hide();
			$("#button-campagne").hide()
			window.valoreModello = "";
			window.numeroTelaio = "";
			$('.select_modelli').keyup();
			this.changeVinCharCounter(e);
			if (this.props.onClick) this.props.onClick({});
			this.setState({ count_campagne: 0, righe_campagne: "" })
		});

		if (this.props.tableType === 'content' || this.props.tableType === 'default'){
			if (common.get_localStorage("valoreVIN") !== undefined && common.get_localStorage("valoreVIN") !== null && common.get_localStorage("valoreVIN") !== '') {
				$("#EDTNTELA").val(common.get_localStorage("valoreVIN")).trigger("change");
			}
		}

	}

	custom_char_counter(char_list, count) {
		const $ = window.$;
		let out = $(".VINCharCounterContainer").html();
		if (!char_list || char_list == '')
			return out;

		let vin_input = $("#EDTNTELA");
		vin_input.attr("maxlength", Math.max(...char_list));
		out = 'Caratteri Inseriti' + ": " + "<span id='charCounterVIN' class='text-danger'>" + count + "</span>";

		return out;
	}

	changeVinCharCounter(e){
		const $ = window.$;
		var strNtela = $("#EDTNTELA").val();
		strNtela = strNtela.replace(/\s+/g, '');
		$("#EDTNTELA").val(strNtela);

		if (this.props.char_vin) {
			let valid_char = this.props.char_vin
			valid_char = valid_char.split(",").map(Number)
			$("#charCounterVIN").text(strNtela.length);
			if (valid_char.includes(strNtela.length)) {
				$("#charCounterVIN").removeClass("text-danger");
				$("#charCounterVIN").addClass("text-success");
			} else {
				$("#charCounterVIN").removeClass("text-success");
				$("#charCounterVIN").addClass("text-danger");
			}
			return true;
		}
		var count = 17 - strNtela.length;
		$("#charCounterVIN").text(count);
		if(count > 0)
			$("#charCounterVIN").addClass("text-danger");
		else
			$("#charCounterVIN").removeClass("text-danger");

		if(e.which === 10 || e.which === 13)
			$("#btn_cercaT").click();
	}

	render(props){
		const $ = window.$;
		var count = 0;
		if($("#EDTNTELA").val() !== undefined && $("#EDTNTELA").val().length !== undefined)
			count = count + $("#EDTNTELA").val().length;

		if(this.props.char_vin > 0){
			let valid_char = this.props.char_vin
			valid_char = valid_char.split(",").map(Number)
			$(".VINCharCounterContainer").html(this.custom_char_counter(valid_char, count))
		}
		var marcaDefault = '';
		if(common.get_localStorage("valoreMarca") !== undefined)
			marcaDefault = common.get_localStorage("valoreMarca");
		else
			marcaDefault = this.props.marcaDefault;

		var is_disabled = false;
		if(this.props.marche_attive !== undefined && this.props.marche_attive.length > 1){
			if(marcaDefault === '' || marcaDefault === 'tutti_modelli')
				is_disabled = true;
		}

		return(
      <div className={(this.props.customClass !== undefined && this.props.customClass !== '' ? this.props.customClass : "col-xl-6 col-lg-6") +  " col-md-12 col-sm-12 col-xs-12 row-eq-height"} role="alert" id="ricerca_filtro_telaio">
        <div className="col-12 p-0">
          <p>{common.getTrad("Ricerca Telaio")}</p>
          <div className="input-group">
			<input disabled={is_disabled} placeholder={is_disabled ? common.getTrad("Seleziona prima una marca") : common.getTrad("Ricerca Telaio")} name="EDTNTELA" id="EDTNTELA" onKeyUp={(e) => this.changeVinCharCounter(e)} className="form-control input-sm text-uppercase" type="text" maxLength="17" />
            <span className="input-group-btn bottone_ricerca">
              	<button disabled={is_disabled} id="btn_cercaT" className="btn btn-light">
							  <span className="d-none d-md-block d-sm-block d-md-none">
                  <span title={common.getTrad("Cerca")} className="fas fa-search initialIcon"></span>
                  <span className="fas fa-spinner fa-spin loadingIcon"></span>
                </span>
							  <span className="d-block d-sm-none">
                  <span className="fas fa-search initialIcon"></span>
                  <span className="fas fa-spinner fa-spin loadingIcon"></span>
                </span>
							</button>
							<button id="resetta_ricerca" className="btn btn-light">
                <span title={common.getTrad("Resetta")} className="fas fa-redo initialIcon"></span>
                <span className="fas fa-spinner fa-spin loadingIcon"></span>
              	</button>
							<button data-toggle="modal" id="button-campagne" title={common.getTrad("Vedi campagne/risanamenti")} data-target="#intCampagnaModal" type="button" className="btn btn-light border rounded int_campagna_ticket" style={{textShadow: "none"}}>
					<span className="mod_gar fa fa-wrench">&nbsp;
					</span> <span className="text-to-hide">{common.getTrad("Vedi campagne/risanamenti")}</span>&nbsp;
					<span className="badge">{this.state.count_campagne}
					</span>
					<div className="modal fade" id="intCampagnaModal" tabindex="-1" role="dialog" aria-labelledby="intCampagnaModalLabel" >
						<div className="modal-dialog modal-lg">
							<div className="modal-content">
								<div className="modal-header">
									<h4 className="modal-title" id="intCampagnaModalLabel" >{common.getTrad("Elenco Aggiornamenti")}</h4>
									<button type="button" class="close" data-dismiss="modal"><span >&times;</span><span class="sr-only">{common.getTrad("Chiudi")}</span></button>
								</div>
								<div clasNames="modal-body">
									<table className="table table-sm table-striped table-bordered" style={{ width: '100%', marginBottom : "0rem" }}>
										<thead>
											<tr>
												<th >{common.getTrad("N. Aggiornamento")}</th>
												<th>{common.getTrad("Descrizione")}</th>
											</tr>
										</thead>
										<tbody>
										</tbody>
									</table>
								</div>
								<div className="modal-footer">
									<button data-dismiss="modal" type="button" id="btn_Cancel" class="btn btn-light" ><span class="fa fa-close"></span>{common.getTrad("Chiudi")}</button>
								</div>
							</div>
						</div>
					</div>
				</button>
            </span>
          </div>
			{this.props.char_vin === 0 ?
				<small class="text-muted VINCharCounterContainer">{common.getTrad("Caratteri rimanenti")}: <span id="charCounterVIN" class="text-danger">17</span></small>
				:
				<small className="text-muted hideVinData">
					{common.getTrad("Caratteri inseriti")}: <span id="charCounterVIN" className={count > 0 ? "text-danger" : ""}>{count}</span>
				</small>
			}
			{this.state.request_url !== undefined && this.state.request_url !== null ?
				<div style={{display: 'none'}} id="erroreVIN" className="sw-alert alert alert-warning" role="alert"></div>
			:
				<></>
			}		
        </div>
      </div>
    )
  }
}

export default FilterChassis;
